import { BrowserJsPlumbDefaults }  from '@jsplumb/community/types/dom/browser-jsplumb-instance.js';
import { EndpointOptions }  from '@jsplumb/community/types/core';
import { JsonTypeShape } from '@kemu-io/hs-types';
import { PortLocation } from '../../types/canvas_t';

export type PortSettingsParameters = {
	isTarget: boolean;
	jsonShape?: JsonTypeShape;
}

type Options = {
	connectionClass: string;
}

/** Default connection between nodes */
export const getDefaultSettings = (options: Options):BrowserJsPlumbDefaults => {
	return {
		// connector: ['Bezier', { curviness: 80, cssClass: options.connectionClass }],
		// connector: ['Straight', { cssClass: options.connectionClass }],
		connector: ['Flowchart', { cssClass: options.connectionClass, gap: 2, stub: 40, cornerRadius: 5 }],
		// endpoint: ['Dot', { radius: 5 }],
		connectionOverlays: [
			[
				'Arrow', {
					foldback: 0,
					height: 10,
					length: 8,
					location: 1,
					width: 12,
				},
			],

			/* [
				"Custom",
				{
					create: (component: Connection) => {
							console.log('component', component);
							const d = document.createElement("div")
							d.className="rotating-custom-overlay"
							d.style.width = "16px"
							d.style.height = "20px"
							d.innerHTML = `<svg width="100%" height="100%" viewBox="0 0 16 21">
																<rect x="0" y="0" fill="red" width="10" height="21"/>
																<rect x="10" y="7" fill="red" width="6" height="7"/>
														</svg>`
							return d
					},
					events: {
						click: (e: Event) => {
							console.log('click', e);
						},
						mouseover: (e: Event) => {
							console.log('hover', e);
						},
					},
					location: -80
				}
			], */
		// 	// [
		// 	// 	'Label',
		// 	// 	{
		// 	// 		location: 0.5,
		// 	// 		id: 'label',
		// 	// 		label: '',
		// 	// 		cssClass: 'conn-label'
		// 	// 	}
		// 	// ],
		],

		// paintStyle: {
		// 	stroke: 'yellow',
		// 	strokeWidth: 5
		// },
		// hoverPaintStyle,
	};
};

/** builds the default settings of a port */
export const getEndpointSetting = (isTarget: boolean, position: PortLocation, radius=6): EndpointOptions => {
	const opts: EndpointOptions = {
		endpoint: ['Dot', { radius }],
		paintStyle: {
			strokeWidth: 2,
			fill: 'none',
		},
		isSource: !isTarget,
		reattach: false,
		connectionsDetachable: true,
		maxConnections: -1,
		isTarget,
		anchor: position,
	};

	return opts;
};
